// @flow

// Order

export const toppingKindOrderString = {
  // seafood: 'シーフードが いっぱい たべたいな',
  vegetable: '[野|や]さいを たくさん [食|た]べたいな。',
  meat: 'お[肉|にく]を いっぱい [食|た]べたいな。',
  //  balance:   'バランスがいい',
};

export const genderBasedOrderStrings = {
  adult: 'おとなに 人気の ピザを ください。',
  child: '子どもに 人気の ピザを ください。',
};

export const dislikeBasedOrderStrings = {
  vegetable: ' [野|や]さいは にがてだなぁ……。',
  meat: 'お[肉|にく]は にがてだなぁ……。',
  no: 'にがてな トッピングは ないよ。',
};

export const simpleOrderString = 'シンプルなピザが [食|た]べたいな。';

export const toppingOpinionString = (kind: 'like' | 'dislike') => {
  if (kind === 'like') return 'が [食|た]べたいな。';
  else return 'は にがてだなぁ……。';
};

export const customerPreferences = {
  adult: ['bell_peeper', 'tomato', 'teriyaki_chicken', 'crab'],
  child: ['corn', 'bacon', 'squid', 'shrimp'],
};

// Hungriness

export const hungrinessString = {
  very_hungry: 'おなかが ペコペコだよ。',
  somewhat_hungry: 'おなか すいたなぁ。',
  normal: ' [何|なに]に しようかなぁ。',
};

export const hungrinessFitTable = {
  very_hungry: {
    thin_crust: -1,
    normal_crust: 0,
    thick_crust: 1,
  },
  somewhat_hungry: {
    thin_crust: 0,
    normal_crust: 1,
    thick_crust: -1,
  },
  normal: {
    thin_crust: 1,
    normal_crust: -1,
    thick_crust: 0,
  },
};

// Disfavors

export const customerDisfavors = {
  man: ['squid'],
  woman: ['salami'],
  child: ['bell_peeper'],
};

// Pizza
export const crustPrices = {
  thin_crust: 40,
  normal_crust: 50,
  thick_crust: 60,
};

export const saucePrices = {
  tomato_sauce: 30,
  white_sauce: 50,
  basil_sauce: 40,
};

export const vegetablePrices = {
  bell_peeper: 60,
  tomato: 120,
  corn: 90,
};

export const meatPrices = {
  salami: 70,
  bacon: 100,
  teriyaki_chicken: 130,
};

export const seafoodPrices = {
  crab: 140,
  squid: 80,
  shrimp: 110,
};

export const tasteFitTable = {
  tomato_sauce: {
    bell_peeper: 1,
    tomato: -1,
    bacon: 1,
  },
  white_sauce: {
    salami: 1,
    shrimp: -1,
    corn: 1,
  },
  basil_sauce: {
    teriyaki_chicken: -1,
    squid: 1,
    shrimp: 1,
  },
};

export const ingredientNames = {
  thin_crust: 'うすい きじ',
  normal_crust: 'ふつうの きじ',
  thick_crust: 'ふっくら きじ',
  tomato_sauce: 'トマトソース',
  white_sauce: 'ホワイトソース',
  basil_sauce: 'バジルソース',
  toppings: {
    bell_peeper: 'ピーマン',
    tomato: 'トマト',
    corn: 'コーン',
    salami: 'サラミ',
    bacon: 'ベーコン',
    teriyaki_chicken: 'チキン',
    crab: 'カニ',
    squid: 'イカ',
    shrimp: 'エビ',
  },
};

export const ingredientIcons = {
  thin_crust: '../../images/pages/pizza/fields/pizza_ic_kiji_usui@3x.png',
  normal_crust: '../../images/pages/pizza/fields/pizza_ic_kiji_futsu@3x.png',
  thick_crust: '../../images/pages/pizza/fields/pizza_ic_kiji_fukkura@3x.png',
  tomato_sauce: '../../images/pages/pizza/fields/pizza_ic_source_tomato@3x.png',
  white_sauce: '../../images/pages/pizza/fields/pizza_ic_source_white@3x.png',
  basil_sauce: '../../images/pages/pizza/fields/pizza_ic_source_basil@3x.png',
  toppings: {
    bell_peeper: '../../images/pages/pizza/fields/pizza_ic_topping_pman@3x.png',
    tomato: '../../images/pages/pizza/fields/pizza_ic_topping_tomato@3x.png',
    corn: '../../images/pages/pizza/fields/pizza_ic_topping_corn@3x.png',
    salami: '../../images/pages/pizza/fields/pizza_ic_topping_salami@3x.png',
    bacon: '../../images/pages/pizza/fields/pizza_ic_topping_bacon@3x.png',
    teriyaki_chicken: '../../images/pages/pizza/fields/pizza_ic_topping_chicken@3x.png',
    crab: '../../images/pages/pizza/fields/pizza_ic_topping_kani@3x.png',
    squid: '../../images/pages/pizza/fields/pizza_ic_topping_ika@3x.png',
    shrimp: '../../images/pages/pizza/fields/pizza_ic_topping_ebi@3x.png',
  },
};

export const calculateCustomerCount = (totalRating: number): number => {
  let customerCount = 1;
  if (totalRating >= 5) customerCount = 2;
  if (totalRating >= 15) customerCount = 3;
  return customerCount;
};

export const ratingToMultiplier = (rating: number): number => {
  return [0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.2, 1.4, 1.6, 2, 2.5][rating + 5];
};
